module.exports = __webpack_public_path__ + "img/logo_howert.2dc7dca0.png";